import * as auth from "/@src/network/auth";
import { api } from "/@src/network/auth";
import { setCurrentUser } from "/@src/helpers/Utils";
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  LOGIN_USER_ERROR,
  REGISTER_USER_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  SET_USER_DETAILS,
  SET_USER_DETAILS_LOADING,
} from "../contants";
import { NotificationManager } from "/@src/components/common/react-notifications";

// User login
export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user,
});

export const loginUserError = (message) => ({
  type: LOGIN_USER_ERROR,
  payload: { message },
});

export const loginUser =
  ({ email, password }) =>
    async (dispatch) => {
      try {
        dispatch(loginUserError(""));
        const loginUser = await auth.signIn(email, password);
        if (!loginUser.message) {
          const { user } = loginUser;
          setCurrentUser(user);
          return dispatch(loginUserSuccess(user));
        } else {
          return dispatch(loginUserError(loginUser.message));
        }
      } catch (error) {
        console.log("error", error, error.response);
        return dispatch(loginUserError(error.response.data.message));
      }
    };

// Register
export const registerUserSuccess = (user) => ({
  type: REGISTER_USER_SUCCESS,
  payload: user,
});

export const registerUserError = (message) => ({
  type: REGISTER_USER_ERROR,
  payload: { message },
});

export const registerUser = (user) => async (dispatch) => {
  try {
    const registerUser = await auth.signUp(user);
    if (!registerUser.message) {
      const { user } = registerUser;
      setCurrentUser(user);
      return dispatch(registerUserSuccess(user));
    } else {
      NotificationManager.error(registerUser.message);
      dispatch(registerUserError(registerUser.message));
    }
  } catch (error) {
    console.error(error);
    NotificationManager.error(error);
    return dispatch(registerUserError(error.response.data.message));
  }
};

// Forgot Password
export const forgotPasswordSuccess = (forgotUserMail) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: forgotUserMail,
});

export const forgotPasswordError = (message) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: { message },
});

export const forgotPassword = (user) => async (dispatch) => {
  try {
    const res = await auth.sendPasswordResetEmail(user.email);
    if (res?.error) {
      return dispatch(forgotPasswordError(res.message));
    } else {
      return dispatch(forgotPasswordSuccess(user.email));
    }
  } catch (error) {
    return dispatch(forgotPasswordError(error.response.data.message));
  }
};

// Reset Password
export const resetPasswordSuccess = (newPassword) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: newPassword,
});

export const resetPasswordError = (message) => ({
  type: RESET_PASSWORD_ERROR,
  payload: { message },
});

export const resetPassword = (data) => async (dispatch) => {
  try {
    const res = await auth.confirmPasswordReset(data);
    if (res?.error) {
      return dispatch(resetPasswordError(res.message));
    } else {
      return dispatch(resetPasswordSuccess(res));
    }
  } catch (error) {
    console.log("error", error);
    return dispatch(resetPasswordError(error.response.data.message));
  }
};

// Logout User
export const logoutUser = (history) => async (dispatch) => {
  await auth
    .signOut()
    .then(() => {
      setCurrentUser();
      return dispatch({
        type: LOGOUT_USER,
        payload: history,
      });
    })
    .catch((error) => error);
};

// User Details
export const getUserDetails = ({ projectId = null, apiKey = null } = {}) => {
  return async (dispatch) => {
    dispatch({
      type: SET_USER_DETAILS_LOADING,
      payload: true,
    });
    try {
      if (projectId && apiKey) {
        dispatch(getUserDetailsForProject({ projectId, apiKey }));
      } else {
        const res = await api.get(`/auth/me`);
        const data = res.data;
        setCurrentUser(data);
        dispatch({
          type: SET_USER_DETAILS,
          payload: data,
        });
        return data;
      }
    } finally {
      dispatch({
        type: SET_USER_DETAILS_LOADING,
        payload: false,
      });
    }
  };
};

export const getUserDetailsForProject = ({ projectId, apiKey } = {}) => {
  return async (dispatch) => {
    dispatch({
      type: SET_USER_DETAILS_LOADING,
      payload: true,
    });
    try {
      const res = await api.get(`/auth/project/${projectId}`, {
        'headers': {
          'Authorization': `Api-key ${apiKey}`
        }
      });
      const { accessToken, refreshToken, user } = res.data;
      auth.setAuthData(accessToken, refreshToken, user)
      setCurrentUser(user);

      dispatch({
        type: SET_USER_DETAILS,
        payload: user,
      });
      return user;
    } catch (e) {
      throw e;
    } finally {
      dispatch({
        type: SET_USER_DETAILS_LOADING,
        payload: false,
      });
    }
  };
};

export const updateUserProfile = (userProfile) => {
  return async (dispatch) => {
    dispatch({
      type: SET_USER_DETAILS_LOADING,
      payload: true,
    });
    try {
      await api.put(`/auth/me/profile`, userProfile);
      dispatch(getUserDetails())
      NotificationManager.success('', 'Profile updated');
    } catch (e) {
      NotificationManager.error(e.message, 'Profile update failed');
      throw e;
    }
  };
};

export const updatePassword = (changePasswordRequest) => {
  return async (dispatch) => {
    dispatch({
      type: SET_USER_DETAILS_LOADING,
      payload: true,
    });
    try {
      await api.put(`/auth/me/updatePassword`, changePasswordRequest);
      dispatch(getUserDetails())
      NotificationManager.success('', 'Password changed succesfully');
    } catch (e) {
      NotificationManager.error(e.message, 'Password change failed');
      throw e;
    }
  };
};